import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Navbar from "./common/Navbar";
import Footer from "./common/Footer";
import Register from "./pages/Register";
import Login from "./pages/Login";
import MoviesPage from "./pages/MoviesPage";
import { AuthRoute } from "./guard/Guard";
import MoviesFormPage from "./pages/MoviesFormPage";

function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/all-movies" element={<MoviesPage />} />

        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />

        <Route
          path="/my-movies"
          element={<AuthRoute element={<MoviesFormPage />} />}
        />

        <Route path="*" element={<Navigate to="/all-movies" />} />
      </Routes>

      <Footer />
    </BrowserRouter>
  );
}

export default App;
